import React, { useState, useEffect } from 'react'
import Datetime from 'react-datetime'
import moment from 'moment'

export default function HoursItem(props) {
  const { open, close, isOpen, isClosed, label } = props.timeBlock

  const onInputChange = updatingObject => {
    props.updateStateHours(props.editingDay, props.timeBlockIndex, {
      ...props.timeBlock,
      ...updatingObject,
    })
  }

  return (
    <div className='hours-item'>
      <form>
        <div>
          <label>Open Time</label>
          <Datetime
            onChange={val => {
              onInputChange({
                open: val.format('HH:mm:ss').toString(),
              })
            }}
            value={moment(open, 'h:mm a').format('h:mm a').toString()}
            dateFormat={false}
            timeFormat='h:mm a'
          />
        </div>

        <div>
          <label>Close Time</label>
          <Datetime
            onChange={val => {
              onInputChange({
                close: val.format('HH:mm:ss').toString(),
              })
            }}
            value={moment(close, 'h:mm a').format('h:mm a').toString()}
            dateFormat={false}
            timeFormat='h:mm a'
          />
        </div>

        <div>
          <label
            htmlFor='Optional Label'
            style={{ color: '#666', fontWeight: '600' }}>
            Optional Label
          </label>
          <input
            type='text'
            value={label}
            onChange={e => {
              onInputChange({
                label: e.target.value,
              })
            }}
            className='form-control'
          />
        </div>

        <div>
          <label htmlFor='isClosed'>
            <input
              checked={isClosed}
              onChange={e => {
                onInputChange({
                  isClosed: e.target.checked,
                })
              }}
              type='checkbox'
            />{' '}
            Closed
          </label>
        </div>

        <div>
          <label htmlFor='isOpen'>
            <input
              checked={isOpen}
              onChange={e => {
                onInputChange({ isOpen: e.target.checked })
              }}
              type='checkbox'
            />{' '}
            Open 24 hours
          </label>
        </div>
        <div>
          <button
            className='btn-danger'
            onClick={() => {
              props.removeTimeblockHours(props.editingDay, props.timeBlockIndex)
            }}>
            X &nbsp; Remove
          </button>
        </div>
      </form>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/Components/HoursInput/HoursItem.js